import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { forkJoin, NEVER, Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { JobService } from '../services/sections/job/job.service';
import { UserContactInfo } from '../models/user-contact-info.model';
import { JobItem } from '../models/job-item.model';
import { UserService } from '../services/sections/shared/user.service';

@Injectable({
	providedIn: 'root'
})
export class NoteThreadResolver implements Resolve<Observable<{ staffMembers: UserContactInfo[], jobs: JobItem[] }>> {

	constructor(
		private router: Router,
		private jobsService: JobService,
		private userService: UserService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		GlobalSettingsService.isSecondaryLoaderLoading = true;

		return forkJoin([
			this.userService.getVendorUsers(activatedRouteSnapshot.paramMap.get('token')),
			this.userService.getAssigneeUsers(activatedRouteSnapshot.paramMap.get('token')),
			this.jobsService.getJobChain(activatedRouteSnapshot.paramMap.get('token'))
		])
			.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				}),
				map(([vendors, assignees, jobs]) => ({
					staffMembers: [...vendors, ...assignees],
					jobs
				}))
			);
	}
}
